import { createNullableProvideInject } from '@collector/shared-ui'

import { IncidentsCustomFiltersConfig } from '../configuration'

export const [
  provideIncidentsCustomFiltersConfig,
  injectIncidentsCustomFiltersConfig,
] = createNullableProvideInject<IncidentsCustomFiltersConfig>(
  'incidentsCustomFiltersConfig',
)
